// src/pages/MemberDashboard.js

import MemberLogin from "./MemberLogin";

// ✅ FIX START
// Dashboard UI already exists inside MemberLogin.js (after OTP verified & approved member).
// So MemberDashboard simply reuses the same component.
// ✅ FIX END

export default function Page() {
  return <MemberLogin />;
}
